<template>
  <!--------底部---------->
  <div class="ltjqjsl">
    <div class="width1200 contxtmeg">
      <h3 class="contxtmegTitle">算力城市</h3>
      <h4>新疆联合智算科技有限公司</h4>
      <span>周一至周日  上午9点至下午20点（中国北京时间）</span>
<!--      <p>请致电：4000-100-3811</p>-->
      <div class="filing-info">
        <p>
          <a class="beian" href="http://beian.miit.gov.cn/" target="_blank">新ICP备2024016726号-1</a>
          <strong>|</strong>
          <img class="imgbeian" src="/image/portalimg/beian.png">
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=65222302000015" rel="noreferrer" target="_blank">新公网安备65222302000015号 </a>
          
        </p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "bottom",
  data(){
    return {
    };
  },
  methods: {}
}
</script>

<style scoped>
.filing-info {
  margin-top: 25px;
  margin-bottom: 8px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-evenly;
  align-items: baseline;
}
.filing-info a {
  color: #7F7F7F;
  font-size: 12px;
  text-decoration: none;
}

.ltjqjsl{
  z-index: 10;
  position: relative;
	width: 100%;
	height: 278px;
	text-align: center;
	background: #EDEFF7;
	background: url(/image/portalimg/bgbottom.png);
	background-size: 100% 100%;
}
.ltjqjsl .contxtmeg h3.contxtmegTitle{
	font-size: 30px;
  color: #191C3D;
  letter-spacing: 10px;
  text-align: center;
  line-height: 58px;
  font-weight: 400;
	padding: 40px 0 0;
  margin: 0;
}
.ltjqjsl .contxtmeg h4{
  font-size: 24px;
  color: #191C3D;
  letter-spacing: 10px;
  text-align: center;
  line-height: 58px;
  font-weight: 400;
  margin: 0;
}
.ltjqjsl .contxtmeg span{
	display: inline-block;
	text-align:center;
	font-size: 12px;
  color: #FFFFFF;
  letter-spacing: 2.5px;
  text-align: center;
  font-weight: 400;
  background:#4173FF;
  padding: 5px 20px;
  margin-top: 20px;
  border-radius:20px;
}
.ltjqjsl .contxtmeg p{
	font-size: 14px;
  color: #333333;
  text-align: center;
  font-weight: 400;
	margin-top: 10px;
  letter-spacing: 0;
}


.ltjqjsl .contxtmeg p .imgbeian{
  display: inline-block;
    width: 20px;
    height: 20px;
    position: relative;
    top: 6px;
    left: -3px;
    padding-left:15px;
}
.ltjqjsl .contxtmeg p strong{
  color: #7f7f7f;
}

.ltjqjsl .contxtmeg p .beian{
  margin-right: 20px;
}

@media (max-width: 768px) {
  /* 移动端样式 */
.ltjqjsl{
  height: auto;
  background-size: 100% ;
  padding-bottom: 5px;
}
  .ltjqjsl .contxtmeg h3.contxtmegTitle{
	font-size: 20px;
  color: #191C3D;
  letter-spacing: 5px;
  text-align: center;
  line-height: 30px;
  font-weight: 400;
	padding: 20px 0 0;
  margin: 0;
}
.ltjqjsl .contxtmeg h4{
  font-size: 15px;
  color: #191C3D;
  letter-spacing: 10px;
  text-align: center;
  line-height: 30px;
  font-weight: 400;
  margin: 0;
}
.ltjqjsl .contxtmeg span{
	display: inline-block;
	text-align:center;
	font-size: 8px;
  color: #FFFFFF;
  letter-spacing: 2.5px;
  text-align: center;
  font-weight: 400;
  background:#4173FF;
  padding: 5px 10px;
  margin-top: 10px;
  border-radius:20px;
}
.filing-info{
  margin-top: 0px;
}

}
</style>
